import React from "react";
import { VMBuilder } from "../../commons/base/providers/builder";
import OptionModel from "../models/option_model";
import SoldOutCmsEditorViewModel from "../view_models/sold_out_cms_editor_view_model";

interface ScreenState {
    selectedMenus: number[];
    vm?: SoldOutCmsEditorViewModel
}

export default class SoldOutCmsDeleteMenu extends React.Component<{}, ScreenState> {

    render(): React.ReactNode {
        return (
            <VMBuilder<SoldOutCmsEditorViewModel>>
                {(vm) => (
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 max-h-screen p-2"
                        onClick={() => vm.closeModal()}
                    >
                        <div
                            className="relative bg-white rounded-lg shadow-lg mt-10 pt-5 px-5 w-full max-w-3xl max-h-[83vh] overflow-y-auto"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {
                                vm.selectedAffectedMenuIds.length > 0
                                ? <AffectedMenuTable 
                                    affectedMenuIds={vm.selectedAffectedMenuIds}
                                    menuMap={vm.menuMap}
                                    deleteMenus={(selectedMenuIds: number[]) => {
                                        vm.deleteSelectedMenuIds(selectedMenuIds, vm.selectedCaseId!, vm.selectedCaseType!)
                                    }}
                                />
                                : <h3>Tidak ada menu untuk item ini</h3>
                            }

                        </div>
                    </div>
                )}
            </VMBuilder>
        )
    }
}

type AffectedMenuTableProps = {
    affectedMenuIds: number[],
    menuMap: Map<number, OptionModel>,
    deleteMenus: (selectedMenuIds: number[]) => void
}

class AffectedMenuTable extends React.Component<
    AffectedMenuTableProps, {
    selectedMenus: number[]
}> {

    constructor(props: AffectedMenuTableProps) {
        super(props);
        this.state = {
            selectedMenus: []
        };
    }

    render(): React.ReactNode {
        const state = this.state;
        const props = this.props;
        return (
            <>
                <h2 className="text-2xl font-bold pb-4">
                    Pilih Untuk Hapus Menu
                </h2>
                <div className="overflow-x-auto mb-4">
                    <table className="table-auto w-full text-center border-collapse my-2">
                        <thead>
                            <tr className="bg-gray-300">
                                <th className="p-2 border border-gray-400 w-1/2">
                                    Menu Id
                                </th>
                                <th className="p-2 border border-gray-400 w-1/2">
                                    Menu
                                </th>
                                <th className="p-2 border border-gray-400 w-1/2">
                                    Hapus
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                props.affectedMenuIds.map((menuId) => {
                                    const menu = props.menuMap.get(menuId);
                                    if (menu) {
                                        const isSelected = state.selectedMenus.indexOf(menuId) != -1;
                                        return <AffectedMenuTableRow 
                                            menuId={menuId}
                                            menuName={menu.title}
                                            isSelected={isSelected}
                                            onChange={(isSelected: boolean) => {
                                                if (isSelected) {
                                                    this.setState({
                                                        selectedMenus: [...state.selectedMenus, menuId]
                                                    })
                                                } else {
                                                    console.log(JSON.stringify(state.selectedMenus));
                                                    this.setState({
                                                        selectedMenus: state.selectedMenus
                                                            .filter((id) => id != menuId)
                                                    });
                                                }
                                            }}
                                        />
                                    }
                                    return null;
                                })
                            }
                        </tbody>
                    </table>
                    <button className="bg-red-500 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg hover:bg-red-600 w-full mt-2"
                    onClick={() => props.deleteMenus(state.selectedMenus)}>
                        Hapus Menu Terpilih
                    </button>
                </div>
            </>
        );
    }
}

class AffectedMenuTableRow extends React.Component<{
    menuId: number,
    menuName: string,
    isSelected: boolean,
    onChange: (isSelected: boolean) => void
}> {
    render(): React.ReactNode {
        let props = this.props;
        console.log(props.menuId);
        return (
            <tr key={props.menuId} className="bg-white" >
                <td className="p-2 border border-gray-400">
                    {props.menuId}
                </td>
                <td className="p-2 border border-gray-400">
                    {props.menuName}
                </td>
                <td className="p-2 border border-gray-400">
                    <input 
                        type="checkbox" 
                        checked={props.isSelected} 
                        name={props.menuId.toString()}
                        onChange={(e) => {
                            this.props.onChange(!this.props.isSelected)
                        }}
                    />
                </td>
            </tr>
        );
    }
}